import { render, staticRenderFns } from "./PropertyPanelHierarchy.vue?vue&type=template&id=5b85727c&"
import script from "./PropertyPanelHierarchy.vue?vue&type=script&lang=ts&"
export * from "./PropertyPanelHierarchy.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyPanelHierarchy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports